import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  Box,
  Drawer,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Grid2 from '@mui/material/Grid2';
import logo from 'assets/images/logoProdutos/alertai_icon_single_light.svg';

interface DeviceEditionComponentProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

type SoundKey = 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90;

const MonitoringOptionsComponent = ({
  isOpen,
  setIsOpen,
}: DeviceEditionComponentProps) => {
  const [state, setState] = useState({
    ivs: true,
    lpr: true,
    gatway: true,
    alarme: true,
    defense: true,
    faciais: true,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const saveToCache = () => {
    localStorage.setItem('monitoringOptions', JSON.stringify({ ...state }));
    setIsOpen(false);
  };

  const loadFromCache = () => {
    const cachedState = localStorage.getItem('monitoringOptions');
    if (cachedState) {
      const parsedState = JSON.parse(cachedState);
      setState(parsedState);
    }
  };

  useEffect(() => {
    loadFromCache();
  }, []);

  return (
    <Drawer open={isOpen} onClose={() => setIsOpen(false)} anchor="right">
      <Grid2
        container
        display={'flex'}
        justifyContent={'center'}
        sx={{ mt: 2, width: 400 }}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Box display={'flex'} justifyItems={'center'} marginY={2}>
          <img key="logo-expanded" height={38} src={logo} />
        </Box>
        <Grid2>
          <hr></hr>
          <Typography sx={{ marginY: 3 }}>
            Mostra somente eventos de:
          </Typography>
          <FormGroup>
            <Box display={'flex'} sx={{ marginY: 3 }}>
              <Grid2 display={'flex'} flexDirection={'column'}>
                <FormControlLabel
                  label="Lpr"
                  control={
                    <Switch
                      checked={state.lpr}
                      onChange={handleChange}
                      name="lpr"
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.ivs}
                      onChange={handleChange}
                      name="ivs"
                    />
                  }
                  label="Ivs"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.gatway}
                      onChange={handleChange}
                      name="gatway"
                    />
                  }
                  label="Gateway"
                />
              </Grid2>
              <Grid2 display={'flex'} flexDirection={'column'}>
                <FormControlLabel
                  label="Alarme"
                  control={
                    <Switch
                      checked={state.alarme}
                      onChange={handleChange}
                      name="alarme"
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.defense}
                      onChange={handleChange}
                      name="defense"
                    />
                  }
                  label="Defense"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.faciais}
                      onChange={handleChange}
                      name="faciais"
                    />
                  }
                  label="Eventos Faciais"
                />
              </Grid2>
            </Box>
          </FormGroup>

          <LoadingButton
            type="submit"
            onClick={saveToCache}
            variant="contained"
            color="primary"
            sx={{ marginY: 2, width: '100%' }}
          >
            Salvar
          </LoadingButton>
        </Grid2>
      </Grid2>
    </Drawer>
  );
};

export default MonitoringOptionsComponent;
